import { scrollThin } from "../../../../../../styles/g-grid-v2/components/scrollbarSelect";
const customHeight = "16px";

const customStyles = {
  container: (provided: any) => ({
    ...provided,
    width: "100%",
  }),


  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: "transparent",
    minHeight: customHeight,
    height: customHeight,
    borderRadius: 6,
    borderColor: state.selectProps.error ? "red" : "#e0e0e0",
    boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided: any, state: any) => ({
    ...provided,
    height: customHeight,
    padding: "0 6px",
  }),

  input: (provided: any, state: any) => ({
    ...provided,
    margin: "0px",
  }),

  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    height: customHeight,
  }),

  dropdownIndicator: (provided: any) => ({
    ...provided,
    display: "none",
  }),

  clearIndicator: (provided: any) => ({
    ...provided,
    padding: "0 0 1px 0",
    height: customHeight,
    display: "flex",
    alignItems: "center",
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    paddingTop: 3,
    paddingBottom: 3,
    fontWeight: "normal",
    textAlign: "center",
    fontSize: 12,
    fontFamily: "Arial",
    overflow: "hidden",
    backgroundColor: state.isFocused ? "#1967d2" : "white",
    color: state.isFocused ? "white" : ""
  }),

  menuList: (provided: any, state: any) => ({
    ...provided,
    ...scrollThin,
    paddingTop: 0,
    paddingBottom: 0
  }),

  menu: (provided: any, state: any) => ({
    ...provided,
    marginTop: 0,
    paddingTop: 0,
    paddingBottom: 0,
    border: "0.2px solid gray",
    borderRadius: "none",
    boxShadow: "0.1em 0.1em 0.5em rgb(12 12 12 / 20%)"
  }),

  placeholder: (provided: any, state: any) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
    gap: 3
  })
};

export default customStyles;
